export * from "./View";
export { default } from "./View";

export * from "./ViewSeo";
export { default as ViewSeo } from "./ViewSeo";
